(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initBlueCatMotion(root = document) {
    if (reduceMotion || !('IntersectionObserver' in window)) return;

    const targets = root.querySelectorAll([
      '.bc-shop__header',
      '.bc-product-card',
      '.bc-gift__media',
      '.bc-gift__inner > div:last-child',
      '.bc-research__inner > div',
      '.bc-faq details'
    ].join(','));

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('bc-is-visible');
        obs.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -36px 0px' });

    targets.forEach((el, index) => {
      if (el.classList.contains('bc-motion-ready')) return;
      el.classList.add('bc-motion-ready');
      el.style.setProperty('--bc-delay', `${Math.min(index % 6, 5) * 55}ms`);
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initBlueCatMotion());
  } else {
    initBlueCatMotion();
  }

  document.addEventListener('shopify:section:load', (event) => initBlueCatMotion(event.target));
})();
